import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const CheckBoxWrapper = styled.div`
    display: ${({ checkboxWrapperDisplay }) =>
        checkboxWrapperDisplay ? checkboxWrapperDisplay : 'flex'};
    flex-direction: row;
    align-items: ${({ alignItemDirection }) =>
        alignItemDirection ? alignItemDirection : 'center'};
    margin: ${({ margin }) => (margin ? margin : '0px')};
    &:hover {
        cursor: ${({ disabled }) => (disabled ? 'no-drop' : 'pointer')};
    }
`;

export const CheckboxLabel = styled.div`
    display: flex;
    text-align: left;
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    letter-spacing: -0.12px;
    color: ${(props) => (props.color ? props.color : '#000000')};
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '0px')};
    margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '0px')};
    margin-bottom: 0px;
    width: 100%;
    align-items: center;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '15px')};
    padding: ${(props) => (props.padding ? props.padding : '')};
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight  : '')};
`;

export const CheckboxFormElement = styled.input`
    margin: 0 !important;
    display: none;
`;

export const CheckBoxImage = styled.img`
    margin: ${(props) => props.checkboxImageMargin};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    ${media.mobileDevice`
    margin:  ${({ checkboxImageMobileMargin }) =>
        checkboxImageMobileMargin ? checkboxImageMobileMargin : ''};
    `}
`;
